<template>
  <b-container>
    <br />
    <b-row class="text-left">
      <b-col>
        <h3 class="text-primary font-weight-bold">Transaction - {{this.$route.params.id}}</h3>
        <br />
        <h5>
          <router-link :to="{name: 'DashboardFinance'}" class="text-primary text-decoration-none">
            <i class="fas fa-long-arrow-alt-left mr-2"></i>Kembali
          </router-link>
        </h5>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-3">
          <b-row>
            <b-col class="border-bottom py-5 text-left px-4">
              <h3>Payment Information</h3>
            </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col md="4" class="border-right py-5 pl-4">
              <h5>Order ID</h5>
              <h5 class="font-weight-bold text-primary">MDTR.T5O7P.BT.EM.C4JRQY21LI.DKGO3</h5>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col md="4" class="border-right py-5 px-4">
                  <h5>Amount</h5>
                  <h5 class="font-weight-bold text-primary">Rp 50.000</h5>
                </b-col>
                <b-col md="4" class="border-right py-5 px-4">
                  <h5>Payment Method</h5>
                  <h5 class="font-weight-bold text-primary">Bank Transfer</h5>
                </b-col>
                <b-col md="4" class="py-5 px-4">
                  <h5>Transaction Status</h5>
                  <h5 class="font-weight-bold text-primary">Pending</h5>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col class="text-left">
        <b-card class="pl-2">
          <h3>Order Details</h3>
          <hr />
          <b-row>
            <b-col md="4">Order ID</b-col>
            <b-col class="font-weight-bold mb-2">MDTR.T5O7P.BT.EM.C4JRQY21LI.DKGO3</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Payment Type</b-col>
            <b-col class="font-weight-bold mb-2">Bank Transfer</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Amount</b-col>
            <b-col class="font-weight-bold mb-2">Rp 50.000</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Transaction ID</b-col>
            <b-col class="font-weight-bold mb-2">85df3ea4-f60b-4c6a-bbb5-0b8c89a2e523</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Time</b-col>
            <b-col class="font-weight-bold mb-2">Today, 14:45</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Status</b-col>
            <b-col class="font-weight-bold mb-2">Pending</b-col>
          </b-row>
        </b-card>
        <br />
        <b-card class="pl-2">
          <h3>Payment Details</h3>
          <hr />
          <b-row>
            <b-col md="4">Virtual Account</b-col>
            <b-col class="font-weight-bold mb-2">1044593686977145</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Acquiring Bank</b-col>
            <b-col class="font-weight-bold mb-2">BCA</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Channel Type</b-col>
            <b-col class="font-weight-bold mb-2">6017</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Referrence ID</b-col>
            <b-col class="font-weight-bold mb-2">-</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Expire Time</b-col>
            <b-col class="font-weight-bold mb-2">20/06/2020 09:14</b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col class="text-left">
        <b-card class="pl-2">
          <h3>Customer Details</h3>
          <hr />
          <b-row>
            <b-col md="4">Username</b-col>
            <b-col class="font-weight-bold mb-2">ahmednr</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Name</b-col>
            <b-col class="font-weight-bold mb-2">Ahmad Nisjdan Rizki</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Phone Number</b-col>
            <b-col class="font-weight-bold mb-2">08987922720</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Email</b-col>
            <b-col class="font-weight-bold mb-2">ahmed@paxel.co</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-2 mx-1">
          <b-row>
            <b-col class="py-3 text-left px-4">
              <h3>Item Details</h3>
            </b-col>
          </b-row>
          <b-row class="text-left bg-gray-200 py-3">
            <b-col class="pl-4" md="3">Commodity ID</b-col>
            <b-col md="3">Product Name</b-col>
            <b-col md="2">Quantity</b-col>
            <b-col md="2">Unit Price</b-col>
            <b-col md="2">Sub Total</b-col>
          </b-row>
          <b-row class="text-left py-3 border-bottom">
            <b-col class="pl-4" md="3">Commodity ID</b-col>
            <b-col md="3">Product Name</b-col>
            <b-col md="2">Quantity</b-col>
            <b-col md="2">Unit Price</b-col>
            <b-col md="2">Sub Total</b-col>
          </b-row>
          <b-row class="text-left py-3 font-weight-bold">
            <b-col class="pl-4" md="3">Today, 14:35</b-col>
            <b-col offset-md="7" md="2">Rp 50.000</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-2 mx-1">
          <b-row>
            <b-col class="py-3 text-left px-4">
              <h3>Payment History</h3>
            </b-col>
          </b-row>
          <b-row class="text-left bg-gray-200 py-3">
            <b-col class="pl-4" md="3">Trade Time</b-col>
            <b-col md="3">Command</b-col>
            <b-col md="2">Amount</b-col>
            <b-col md="2">Result</b-col>
            <b-col md="2">By</b-col>
          </b-row>
          <b-row class="text-left py-3 border-bottom">
            <b-col class="pl-4" md="3">Yesterday, 10:16 pm</b-col>
            <b-col md="3">Charge Transaction</b-col>
            <b-col md="2">Rp 50.000</b-col>
            <b-col md="2">Success</b-col>
            <b-col md="2">System</b-col>
          </b-row>
          <b-row class="text-left py-3 border-bottom">
            <b-col class="pl-4" md="3">Yesterday, 10:16 pm</b-col>
            <b-col md="3">Charge Transaction</b-col>
            <b-col md="2">Rp 50.000</b-col>
            <b-col md="2">Success</b-col>
            <b-col md="2">System</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {};
</script>

<style>
</style>